import React, { useState } from 'react';
import CategoryBanner from './CategoryBanner';
import axiosInstance from '../../../config/axiosInterceptor';

const CategoryBannerUser = () => {
    const [searchUserId, setSearchUserId] = useState('');
    const [username, setUsername] = useState('');
    const [userImage, setUserImage] = useState('');

    const handleSearch = async () => {
        if (!searchUserId) return;
        try {
            const response = await axiosInstance.get(
                `${process.env.REACT_APP_BASEURL5}/coin/recharge/sendCoinfetchuser?userId=${searchUserId}`
            );
            const res = response.data;
            if (res.success === 1 && res.details?.username) {
                setUsername(res.details.username);
                setUserImage(res.details.picture || '/default-user.png');
            } else {
                alert("User not found or missing data.");
            }
        } catch (error) {
            console.error("API Error:", error);
            alert("Something went wrong while fetching user.");
        }
    };

    const overlays = {
        singer: "/singer.jpg",
        fashion: "/fashion.jpg",
        dancer: "/dancer.jpg",
        standup: "/standup.jpg",
    };

    const imagePositionMap = {
        singer: { bottom: "25%", left: "36%", width: "166px", height: "200px", position: 'absolute' },
        fashion: { bottom: "21%", left: "30%", width: "230px", height: "270px", position: 'absolute' },
        dancer: { bottom: "24.5%", left: "28.5%", width: "256px", height: "270px", position: 'absolute' },
        standup: { bottom: "24.5%", left: "30%", width: "238px", height: "246px", position: 'absolute' },
    };

    const usernamePositionMap = {
        singer: { bottom: "6%", left: "40%", position: 'absolute', color: "#fff", fontSize: "20px", fontWeight: "bold" },
        fashion: { bottom: "8.5%", left: "40%", position: 'absolute', color: "#fff", fontSize: "20px" },
        dancer: { bottom: "20%", left: "42%", position: 'absolute', color: "#fff", fontSize: "20px" },
        standup: { bottom: "20%", left: "40%", position: 'absolute', color: "#fff", fontSize: "20px" },
    };

    return (
        <div style={{
            minHeight: "100vh",
            backgroundColor: "#f3f4f6",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px"
        }}>
            <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                <input
                    type="text"
                    placeholder="Enter User ID"
                    value={searchUserId}
                    onChange={(e) => setSearchUserId(e.target.value)}
                    style={{
                        padding: "10px 14px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        fontSize: "16px",
                        width: "200px"
                    }}
                />
                <button
                    onClick={handleSearch}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#3B82F6",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        fontSize: "16px",
                        cursor: "pointer"
                    }}
                >
                    Go
                </button>
            </div>

            <CategoryBanner
                userImage={userImage ? `${process.env.REACT_APP_BASEURL}${userImage}` : "/mastiLive_logo.png"}
                username={`${username?.slice(0, 9)}..` || "Username"}
                overlays={overlays}
                imagePositionMap={imagePositionMap}
                usernamePositionMap={usernamePositionMap}
            />
        </div>
    );
};

export default CategoryBannerUser;
